import { RowData } from '../components/tables/MasterTable'
import { phoneNumbers } from '../components/countries/PhoneDial'

export const getCountryName = (dial_code: string) => {
  const country = phoneNumbers.find((country) => country.dial_code === dial_code)
  return country ? country.name : ''
}

export const getCountry = (country_code: string) => {
  const country = phoneNumbers.find((country) => country.code.toLowerCase() === country_code)
  return country ? country.name : ''
}

export const peopleData: RowData[] = [
  {
    id: 1,
    firstName: 'Alice',
    lastName: 'Johnson',
    currentPosition: 'Senior Manager',
    previousPosition: 'Manager',
    teamName: 'Design1',
    country: getCountryName('+1'),
    phoneCountry: '+1',
    personalEmail: 'alice.johnson@example.com',
    workEmail: 'alice@work.com',
    hoursperweek: 40,
    startDate: 'January 10, 2015',
    contractType: 'Full-time',
    manager: 'N/A',
    hoursinOffice: 30,
    hoursinHome: 10,
    gender: 'Female',
    phoneNumber: '123-456-7890',
    address: '123 Maple St, Anytown, Canada',
    dob: 'March 15, 1980',
    actions: '',
  },
  {
    id: 2,
    firstName: 'Bob',
    lastName: 'Smith',
    currentPosition: 'Manager',
    previousPosition: 'Team Lead',
    teamName: 'Development',
    country: getCountryName('+1'),
    phoneCountry: '+1',
    personalEmail: 'bob.smith@example.com',
    workEmail: 'bob@work.com',
    hoursperweek: 40,
    startDate: 'February 20, 2010',
    contractType: 'Full-time',
    manager: 'N/A',
    hoursinOffice: 35,
    hoursinHome: 5,
    gender: 'Male',
    phoneNumber: '234-567-8901',
    address: '456 Oak St, Anytown, USA',
    dob: 'April 25, 1975',
    actions: '',
  },
  {
    id: 3,
    firstName: 'Sarah',
    lastName: 'Lee',
    currentPosition: 'Product Manager',
    previousPosition: 'Team Lead',
    teamName: 'Product',
    country: getCountryName('+44'),
    phoneCountry: '+44',
    personalEmail: 'sarah.lee@example.com',
    workEmail: 'sarah@work.com',
    hoursperweek: 40,
    startDate: 'March 15, 2012',
    contractType: 'Full-time',
    manager: 'N/A',
    hoursinOffice: 25,
    hoursinHome: 15,
    gender: 'Female',
    phoneNumber: '345-678-9012',
    address: '789 Birch St, Anytown, UK',
    dob: 'May 10, 1982',
    actions: '',
  },
  {
    id: 4,
    firstName: 'Emma',
    lastName: 'Brown',
    currentPosition: 'QA Manager',
    previousPosition: 'Team Lead',
    teamName: 'Quality Assurance',
    country: getCountryName('+61'),
    phoneCountry: '+61',
    personalEmail: 'emma.brown@example.com',
    workEmail: 'emma@work.com',
    hoursperweek: 40,
    startDate: 'June 1, 2013',
    contractType: 'Full-time',
    manager: 'N/A',
    hoursinOffice: 30,
    hoursinHome: 10,
    gender: 'Female',
    phoneNumber: '456-789-0123',
    address: '321 Pine St, Anytown, Australia',
    dob: 'July 20, 1985',
    actions: '',
  },
  {
    id: 5,
    firstName: 'Olivia',
    lastName: 'Green',
    currentPosition: 'HR Manager',
    previousPosition: 'Team Lead',
    teamName: 'Human Resources',
    country: getCountryName('+49'),
    phoneCountry: '+49',
    personalEmail: 'olivia.green@example.com',
    workEmail: 'olivia@work.com',
    hoursperweek: 40,
    startDate: 'August 15, 2011',
    contractType: 'Full-time',
    manager: 'N/A',
    hoursinOffice: 35,
    hoursinHome: 5,
    gender: 'Female',
    phoneNumber: '567-890-1234',
    address: '654 Cedar St, Anytown, Germany',
    dob: 'September 18, 1983',
    actions: '',
  },
  {
    id: 6,
    firstName: 'Lucas',
    lastName: 'White',
    currentPosition: 'Marketing Manager',
    previousPosition: 'Team Lead',
    teamName: 'Marketing',
    country: getCountryName('+33'),
    phoneCountry: '+33',
    personalEmail: 'lucas.white@example.com',
    workEmail: 'lucas@work.com',
    hoursperweek: 40,
    startDate: 'October 10, 2014',
    contractType: 'Full-time',
    manager: 'N/A',
    hoursinOffice: 25,
    hoursinHome: 15,
    gender: 'Male',
    phoneNumber: '678-901-2345',
    address: '987 Spruce St, Anytown, France',
    dob: 'November 25, 1980',
    actions: '',
  },
  {
    id: 7,
    firstName: 'Isabella',
    lastName: 'Clark',
    currentPosition: 'Sales Manager',
    previousPosition: 'Team Lead',
    teamName: 'Sales',
    country: getCountryName('+34'),
    phoneCountry: '+34',
    personalEmail: 'isabella.clark@example.com',
    workEmail: 'isabella@work.com',
    hoursperweek: 40,
    startDate: 'December 5, 2009',
    contractType: 'Full-time',
    manager: 'N/A',
    hoursinOffice: 20,
    hoursinHome: 20,
    gender: 'Female',
    phoneNumber: '789-012-3456',
    address: '123 Elm St, Anytown, Spain',
    dob: 'January 30, 1981',
    actions: '',
  },
  {
    id: 8,
    firstName: 'Mia',
    lastName: 'Lewis',
    currentPosition: 'Business Analyst',
    previousPosition: 'Junior Business Analyst',
    teamName: 'Business Analysis',
    country: getCountryName('+39'),
    phoneCountry: '+39',
    personalEmail: 'mia.lewis@example.com',
    workEmail: 'mia@work.com',
    hoursperweek: 40,
    startDate: 'February 25, 2010',
    contractType: 'Full-time',
    manager: 'N/A',
    hoursinOffice: 30,
    hoursinHome: 10,
    gender: 'Female',
    phoneNumber: '890-123-4567',
    address: '456 Willow St, Anytown, Italy',
    dob: 'March 14, 1982',
    actions: '',
  },
  {
    id: 9,
    firstName: 'Ava',
    lastName: 'Walker',
    currentPosition: 'Operations Manager',
    previousPosition: 'Team Lead',
    teamName: 'Operations',
    country: getCountryName('+55'),
    phoneCountry: '+55',
    personalEmail: 'ava.walker@example.com',
    workEmail: 'ava@work.com',
    hoursperweek: 40,
    startDate: 'April 12, 2008',
    contractType: 'Full-time',
    manager: 'N/A',
    hoursinOffice: 35,
    hoursinHome: 5,
    gender: 'Female',
    phoneNumber: '012-345-6789',
    address: '789 Maple St, Anytown, Brazil',
    dob: 'May 2, 1980',
    actions: '',
  },
  {
    id: 10,
    firstName: 'Sophia',
    lastName: 'Scott',
    currentPosition: 'Finance Manager',
    previousPosition: 'Team Lead',
    teamName: 'Finance',
    country: getCountryName('+81'),
    phoneCountry: '+81',
    personalEmail: 'sophia.scott@example.com',
    workEmail: 'sophia@work.com',
    hoursperweek: 40,
    startDate: 'June 1, 2009',
    contractType: 'Full-time',
    manager: 'N/A',
    hoursinOffice: 25,
    hoursinHome: 15,
    gender: 'Female',
    phoneNumber: '123-456-7890',
    address: '321 Birch St, Anytown, Japan',
    dob: 'July 20, 1981',
    actions: '',
  },
  {
    id: 11,
    firstName: 'Ethan',
    lastName: 'Miller',
    currentPosition: 'Frontend Developer',
    previousPosition: 'Junior Frontend Developer',
    teamName: 'Development',
    country: getCountryName('+1'),
    phoneCountry: '+1',
    personalEmail: 'ethan.miller@example.com',
    workEmail: 'ethan@work.com',
    hoursperweek: 40,
    startDate: 'January 15, 2021',
    contractType: 'Full-time',
    manager: 'Bob Smith',
    hoursinOffice: 30,
    hoursinHome: 10,
    gender: 'Male',
    phoneNumber: '234-567-8901',
    address: '123 Oak St, Anytown, USA',
    dob: 'February 20, 1995',
    actions: '',
  },
  {
    id: 12,
    firstName: 'Ava',
    lastName: 'Martinez',
    currentPosition: 'Backend Developer',
    previousPosition: 'Junior Backend Developer',
    teamName: 'Development',
    country: getCountryName('+1'),
    phoneCountry: '+1',
    personalEmail: 'ava.martinez@example.com',
    workEmail: 'ava@work.com',
    hoursperweek: 40,
    startDate: 'March 10, 2020',
    contractType: 'Full-time',
    manager: 'Bob Smith',
    hoursinOffice: 25,
    hoursinHome: 15,
    gender: 'Female',
    phoneNumber: '345-678-9012',
    address: '456 Maple St, Anytown, Canada',
    dob: 'April 15, 1992',
    actions: '',
  },
  {
    id: 13,
    firstName: 'Liam',
    lastName: 'Johnson',
    currentPosition: 'Team Lead',
    previousPosition: 'Senior Developer',
    teamName: 'Development',
    country: getCountryName('+44'),
    phoneCountry: '+44',
    personalEmail: 'liam.johnson@example.com',
    workEmail: 'liam@work.com',
    hoursperweek: 40,
    startDate: 'May 5, 2018',
    contractType: 'Full-time',
    manager: 'Bob Smith',
    hoursinOffice: 30,
    hoursinHome: 10,
    gender: 'Male',
    phoneNumber: '456-789-0123',
    address: '789 Birch St, Anytown, UK',
    dob: 'June 10, 1985',
    actions: '',
  },
  {
    id: 14,
    firstName: 'Sophia',
    lastName: 'Williams',
    currentPosition: 'Marketing Specialist',
    previousPosition: 'Junior Marketing Specialist',
    teamName: 'Marketing',
    country: getCountryName('+61'),
    phoneCountry: '+61',
    personalEmail: 'sophia.williams@example.com',
    workEmail: 'sophia@work.com',
    hoursperweek: 40,
    startDate: 'July 20, 2017',
    contractType: 'Full-time',
    manager: 'Lucas White',
    hoursinOffice: 35,
    hoursinHome: 5,
    gender: 'Female',
    phoneNumber: '567-890-1234',
    address: '321 Pine St, Anytown, Australia',
    dob: 'August 25, 1988',
    actions: '',
  },
  {
    id: 15,
    firstName: 'James',
    lastName: 'Brown',
    currentPosition: 'Frontend Developer',
    previousPosition: 'Junior Frontend Developer',
    teamName: 'Development',
    country: getCountryName('+1'),
    phoneCountry: '+1',
    personalEmail: 'james.brown@example.com',
    workEmail: 'james@work.com',
    hoursperweek: 40,
    startDate: 'August 10, 2021',
    contractType: 'Full-time',
    manager: 'Bob Smith',
    hoursinOffice: 30,
    hoursinHome: 10,
    gender: 'Male',
    phoneNumber: '678-901-2345',
    address: '123 Elm St, Anytown, USA',
    dob: 'September 15, 1993',
    actions: '',
  },
  {
    id: 16,
    firstName: 'Emily',
    lastName: 'Davis',
    currentPosition: 'Backend Developer',
    previousPosition: 'Junior Backend Developer',
    teamName: 'Development',
    country: getCountryName('+1'),
    phoneCountry: '+1',
    personalEmail: 'emily.davis@example.com',
    workEmail: 'emily@work.com',
    hoursperweek: 40,
    startDate: 'October 5, 2020',
    contractType: 'Full-time',
    manager: 'Bob Smith',
    hoursinOffice: 25,
    hoursinHome: 15,
    gender: 'Female',
    phoneNumber: '789-012-3456',
    address: '456 Oak St, Anytown, Canada',
    dob: 'November 20, 1991',
    actions: '',
  },
  {
    id: 17,
    firstName: 'Michael',
    lastName: 'Wilson',
    currentPosition: 'Frontend Developer',
    previousPosition: 'Junior Frontend Developer',
    teamName: 'Development',
    country: getCountryName('+44'),
    phoneCountry: '+44',
    personalEmail: 'michael.wilson@example.com',
    workEmail: 'michael@work.com',
    hoursperweek: 40,
    startDate: 'December 15, 2019',
    contractType: 'Full-time',
    manager: 'Bob Smith',
    hoursinOffice: 30,
    hoursinHome: 10,
    gender: 'Male',
    phoneNumber: '890-123-4567',
    address: '789 Birch St, Anytown, UK',
    dob: 'January 25, 1990',
    actions: '',
  },
  {
    id: 18,
    firstName: 'Emma',
    lastName: 'Taylor',
    currentPosition: 'Backend Developer',
    previousPosition: 'Junior Backend Developer',
    teamName: 'Development',
    country: getCountryName('+61'),
    phoneCountry: '+61',
    personalEmail: 'emma.taylor@example.com',
    workEmail: 'emma@work.com',
    hoursperweek: 40,
    startDate: 'February 10, 2021',
    contractType: 'Full-time',
    manager: 'Bob Smith',
    hoursinOffice: 25,
    hoursinHome: 15,
    gender: 'Female',
    phoneNumber: '012-345-6789',
    address: '321 Pine St, Anytown, Australia',
    dob: 'March 15, 1994',
    actions: '',
  },
]
